import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Label } from 'core/components/label';
import useStyles from './system-error.styles';

// Renders a date as e.g. "5/5/2026, 9:05 AM EST" in Eastern time, matching the
// "Time of error" row in the Figma design (GitHub #30224).
const formatTimeOfError = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short'
  });
};

const TechnicalDetails = ({ code, type, timestamp }) => {
  const classes = useStyles();
  const timeOfError = formatTimeOfError(timestamp);

  const rows = [
    { label: 'Error code', value: code },
    { label: 'Error type', value: type },
    { label: 'Time of error', value: timeOfError }
  ].filter((row) => row.value !== null && row.value !== undefined && row.value !== '');

  if (!rows.length) {
    return null;
  }

  return (
    <div className={classes.technicalDetails}>
      <Label type="body1Bold" className={classes.technicalDetailsTitle}>
        Technical details
      </Label>
      <div className={classes.table}>
        {rows.map((row, index) => (
          <Fragment key={row.label}>
            {index > 0 && <div className={classes.divider} />}
            <div className={classes.row}>
              <Label type="body2" className={classes.rowLabel}>
                {row.label}
              </Label>
              <Label type="body2Bold" className={classes.rowValue}>
                {row.value}
              </Label>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

TechnicalDetails.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  timestamp: PropTypes.string
};

export default TechnicalDetails;
